import {
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
} from "@chakra-ui/react";
import { TabHeader } from "components/TabHeader";
import { CloseButton } from "components/RFQ/CloseButton";
import EmailPreview from "pages/EmailPreview/EmailPreview";
import { useRfxMail } from "components/email-template/hooks/useRfxMail";
import { Rfx } from "newui/features/Rfx/types/rfx.types";
import { InviteForPreApprovalEmailContent } from "components/email-template/InviteForPreApprovalEmailContent";
import { GuestSelectorV2 } from "../GuestSelector/GuestSelectorV2";
import { useMemo } from "react";
import { isRfxOnboardingType } from "newui/features/Rfx/utils";

type InvitePreApprovalDrawerProps = {
	isOpen: boolean;
	rfqName: string;
	rfx: Rfx;
	onClose: () => void;
};

const InvitePreApprovalDrawer = ({
	rfqName,
	onClose,
	isOpen,
	rfx,
	...props
}: InvitePreApprovalDrawerProps) => {
	const { rfxMail, additionalMessage, handleAdditionalMessageChange } =
		useRfxMail(rfx);

	const handleMessageChange = (e) => {
		handleAdditionalMessageChange(e.target.value);
	};
	const header = "Invite Others to Approve Draft RFx";
	const headerDescription =
		"Invite others who need to approve this RFx prior to it being submitted to Suppliers to respond to.";

	const onAfterSubmit = (approvers) => {
		if (approvers) {
			if (rfx.rfxApprovers) {
				rfx.rfxApprovers = [...approvers];
			} else {
				rfx.rfxApprovers = approvers;
			}
		}
	};

	const isOnboarding = useMemo(() => {
		return isRfxOnboardingType(rfx?.rfxType);
	}, [rfx?.rfxType]);

	return (
		<Drawer
			placement={"right"}
			isOpen={isOpen}
			onClose={onClose}
			size="xl"
			{...props}
		>
			<DrawerOverlay onClick={onClose} />
			<DrawerContent maxWidth={"85%"}>
				<DrawerHeader
					className="!px-0 py-6 text-black"
					borderBottomWidth="1px"
				>
					<div className="mx-6">
						<TabHeader
							noDivider={true}
							heading={header}
							description={headerDescription}
						>
							<CloseButton onClose={onClose} />
						</TabHeader>
					</div>
				</DrawerHeader>
				<DrawerBody className="max-h-[calc(100vh - 100px)] p-6">
					<div className="grid grid-cols-2">
						<div className="space-y-4 p-4">
							<GuestSelectorV2
								additionalMessage={additionalMessage}
								handleAdditionalMessageChange={handleMessageChange}
								afterSubmit={onAfterSubmit}
								onClose={onClose}
								rfxUuid={rfx?.uuid}
							/>
							{/* <SupplierSelector
								// 	additionalMessage={additionalMessage}
								// 	supplierList={rfx?.supplierList}
								// 	handleAdditionalMessageChange={handleMessageChange}
								// 	handleSubmit={handleRFQActionSubmit}
								// 	handleSupplierChange={handleSupplierChange}
								 />*/}
						</div>
						<div>
							<EmailPreview>
								{
									<InviteForPreApprovalEmailContent
										isOnboarding={isOnboarding}
										rfxMail={rfxMail}
									/>
								}
							</EmailPreview>
						</div>
					</div>
				</DrawerBody>
			</DrawerContent>
		</Drawer>
	);
};
export default InvitePreApprovalDrawer;
